import { Descriptions } from 'antd';
import { DIAMETER_NOMINAL_LABELS } from '@enmon/commons';
import { deviceCategoryTranslated, orientationTranslated } from 'components/Form/meter_details/constants';
import { FormattedMessage, IntlShape } from 'react-intl';
import { MeterDetailGas } from '@enmon/commons/lib/enmon';
import { MeterDetails as messages } from './messages';

export const getGasDetailDescriptions = (details: MeterDetailGas | undefined, intl: IntlShape) => {
  const { deviceCategory, measurementCategory, layLength, orientation, gSize, pMax, qMax, qMin, diameterNominal } =
    details ?? {};

  return (
    <>
      <Descriptions.Item label={<FormattedMessage {...messages.deviceType} />}>
        {deviceCategory && intl.formatMessage(deviceCategoryTranslated[deviceCategory])}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.measurementCategory} />}>
        {measurementCategory}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.orientation} />}>
        {orientation && intl.formatMessage(orientationTranslated[orientation])}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.gSize} />}>
        {gSize} {`m${String.fromCharCode(179)}/h`}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.diameterNominal} />}>
        {diameterNominal && DIAMETER_NOMINAL_LABELS[diameterNominal]}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.layLength} />}>
        {layLength && `${layLength} mm`}
      </Descriptions.Item>
      <Descriptions.Item label="Pmax">{pMax} MPa</Descriptions.Item>
      <Descriptions.Item label="Qmin">
        {qMin} {`m${String.fromCharCode(179)}/h`}
      </Descriptions.Item>
      <Descriptions.Item label="Qmax">
        {qMax} {`m${String.fromCharCode(179)}/h`}
      </Descriptions.Item>
    </>
  );
};
